import { get } from 'core_main/request';
import { ROOT_CATEGORY_ENDPOINT } from './constants';
import {
  makeGetCategoriesEndpoint,
  makeGetCategoryEndpoint,
  validateFetchCategoriesParameters,
  validateFetchCategoryByIdParameters,
} from './helpers';
import {
  FetchCategoriesParameters,
  FetchCategoryByIdParameters,
} from './types';

export const fetchCategories = (parameters: FetchCategoriesParameters) => {
  const validationError = validateFetchCategoriesParameters(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return get(makeGetCategoriesEndpoint(parameters));
};
export const fetchRootCategory = () => {
  return get(ROOT_CATEGORY_ENDPOINT);
};
export const fetchCategoryById = (parameters: FetchCategoryByIdParameters) => {
  const validationError = validateFetchCategoryByIdParameters(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return get(makeGetCategoryEndpoint(parameters));
};
